import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-views',
    templateUrl: './views.component.html',
    standalone: false
})
export class ViewsComponent implements OnInit {

  // The landing page now lives in HomeComponent, which is routed at '' and forwards
  // signed-in users to /app. This shell is no longer routed anywhere.
  constructor() { }

  ngOnInit() {

  }

}
